import { ArrowRight, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { whatsappLink } from "../../../src/data/services";

export default function Hero() {
  return (
    <section
      data-testid="home-hero"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/15672074/pexels-photo-15672074.jpeg"
          alt="Edificio corporativo moderno"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(110deg, rgba(10,25,47,0.96) 0%, rgba(10,25,47,0.85) 45%, rgba(10,25,47,0.55) 100%)",
          }}
        />
        <div className="absolute inset-0 navy-texture opacity-60" />
      </div>

      <div className="container-x relative z-10 pt-28 pb-20 md:pt-32 md:pb-28">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6 animate-fade-up">
            <span className="gold-rule" />
            <span className="overline">Cartagena · Cobertura nacional</span>
          </div>

          <h1
            className="font-serif text-white animate-fade-up"
            style={{
              fontSize: "clamp(2.25rem, 5vw, 4.25rem)",
              lineHeight: 1.05,
              fontWeight: 500,
              animationDelay: "60ms",
            }}
          >
            Asesoría jurídica y contable{" "}
            <em className="font-serif italic" style={{ color: "#C5A059" }}>
              estratégica
            </em>{" "}
            para empresas que buscan crecer con seguridad.
          </h1>

          <p
            className="mt-7 text-base md:text-lg text-slate-200/90 max-w-2xl leading-relaxed animate-fade-up"
            style={{ animationDelay: "180ms" }}
          >
            En <strong className="text-white font-medium">Ospino &amp; Piñeres Abogados &amp; Asociados S.A.S.</strong> ofrecemos soluciones integrales que fortalecen la toma de decisiones, el cumplimiento normativo y la sostenibilidad empresarial.
          </p>

          <div
            className="mt-10 flex flex-col sm:flex-row gap-4 animate-fade-up"
            style={{ animationDelay: "300ms" }}
          >
            <a
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-agendar"
              className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-sm text-sm font-medium tracking-wide text-navy-900 bg-gold hover:bg-gold-600 transition-all"
              style={{ background: "#C5A059" }}
            >
              <MessageCircle size={17} />
              Agendar consulta
            </a>
            <Link
              to="/contacto"
              data-testid="hero-cta-contactanos"
              className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-sm text-sm font-medium tracking-wide text-white border border-white/40 hover:bg-white hover:text-navy-900 transition-all"
            >
              Contáctanos
              <ArrowRight size={16} />
            </Link>
          </div>

          {/* Trust micro */}
          <div
            className="mt-16 flex flex-wrap gap-x-10 gap-y-4 animate-fade-up"
            style={{ animationDelay: "420ms" }}
          >
            {[
              ["13+", "Áreas de práctica"],
              ["Multidisciplinario", "Abogados y contadores"],
              ["Nacional", "Cobertura territorial"],
            ].map(([k, v]) => (
              <div key={v} className="flex items-baseline gap-3">
                <span
                  className="font-serif text-2xl"
                  style={{ color: "#C5A059", fontWeight: 600 }}
                >
                  {k}
                </span>
                <span className="text-xs uppercase tracking-[0.2em] text-slate-300">
                  {v}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:flex flex-col items-center gap-2 text-white/60">
        <span className="text-[10px] uppercase tracking-[0.3em]">Descubrir</span>
        <span className="block w-px h-10 bg-white/40" />
      </div>
    </section>
  );
}